import type { Transition } from "@uirouter/core";

import { ACTIVATION_HOME_ROUTE } from "app/pages/activation/routing/constants";
import { createActivationApi } from "app/pages/activation/services/api";

export const onSettingsRedirect = () => async (transition: Transition) => {
    const toParams = transition.params("to");

    if (!toParams?.key) {
        return transition.router.stateService.target(ACTIVATION_HOME_ROUTE);
    }

    const api = createActivationApi();

    try {
        const activationSet = await api.activation.getActivationById(toParams?.key);

        if (!activationSet) {
            return transition.router.stateService.target(ACTIVATION_HOME_ROUTE);
        }
    } catch {
        return transition.router.stateService.target(ACTIVATION_HOME_ROUTE);
    }

    return;
};
